export default __webpack_public_path__ + "static/media/passive-auth-en-light.3f46fadd.png";